import { useFeatureFlagEnabled } from "posthog-js/react";

export const useOffersPagePath = (customerDomain: string, productRequestId: string | null | undefined): string => {
  const offersPageV2Enabled = useFeatureFlagEnabled("offers_page_v2");

  if (offersPageV2Enabled && productRequestId) {
    return `/${customerDomain}/financing/${productRequestId}/offers`;
  }

  return `/${customerDomain}/financing/funds-request/offers`;
};
